import React, { useEffect, useState } from 'react';
import { Card, Col, Empty, Row, Skeleton } from 'antd';
import styled from 'styled-components/macro';
import { Helmet } from 'react-helmet';

import { getCampaignsHosts } from 'utils/apis/campaigns';
import { useFetchConstant } from 'utils/hooks/general';

import CampaignCard from 'components/CampaignCard/CampaignCard';

import HostProfileImage from './images/host-partners-banner.jpg';

const BannerContainer = styled(Row)`
  margin: -24px -11% 0 !important;
  height: auto;

  @media (min-width: 768px) {
    margin: 0 -11% !important;
  }
`;

const ListingCard = styled(Card)`
  flex-direction: column;
  background-color: ${props => props.theme.color.white} !important;
  margin: 0 auto auto auto !important;
  border: 0 !important;
  height: 100%;
  @media (min-width: 992px) {
    flex-direction: row;
  }
`;

const CardContainer = styled(Col)`
  margin-bottom: 32px;
`;

const useGetCampaignsHosts = () => {
  const [campaignsHosts, setCampaignsHosts] = useState([]);
  const [isCampaignsHostsLoading, setIsCampaignsHostsLoading] = useState(true);
  const { selections: states, isLoading } = useFetchConstant('statesMY');

  useEffect(() => {
    if (!isLoading) {
      getCampaignsHosts({ isAll: true }).then(data => {
        const formattedCampaignsHosts = formatCampaignsHostsByCampaign(data, states);
        setCampaignsHosts(formattedCampaignsHosts);
        setIsCampaignsHostsLoading(false);
      });
    }
  }, [isLoading, states]);
  return { campaignsHosts, isCampaignsHostsLoading };
};

const formatCampaignsHostsByCampaign = (campaignsHosts = [], states = []) => {
  return campaignsHosts.map(campaignHost => {
    if (campaignHost.coveredAreas && campaignHost.coveredAreas.length > 0) {
      campaignHost.coveredAreas = campaignHost.coveredAreas.map(coveredArea => {
        const foundState = states.find(state => String(state.code) === String(coveredArea));
        return foundState.label;
      });
    }
    return campaignHost;
  });
};

const HostProfileListing = () => {
  const { originalSelection: campaignVotingTypesConstant } = useFetchConstant('campaignVotingTypes');
  const { campaignsHosts, isCampaignsHostsLoading } = useGetCampaignsHosts();

  return (
    <Row>
      <Helmet>
        <title>Our Host Partners | HostAStay</title>
        <meta name="description" content="Get connected to professional, trusted & verified hosts." />
      </Helmet>
      <BannerContainer>
        <img src={HostProfileImage} width="100%" height="auto" alt="Get connected to professional, trusted & verified hosts." />
      </BannerContainer>
      <ListingCard>
        {!isCampaignsHostsLoading ? (
          <Row type="flex" gutter={16}>
            {campaignsHosts.length > 0 ? (
              campaignsHosts.map(item => (
                <CardContainer span={24} md={12} lg={8} xl={6} xxl={4} key={item._id}>
                  <CampaignCard type={campaignVotingTypesConstant.HOST.code} data={item} />
                </CardContainer>
              ))
            ) : (
              <Col span={24} style={{ padding: '32px' }}>
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span style={{ color: 'rgba(0,0,0,0.25)' }}>No hosts</span>} />
              </Col>
            )}
          </Row>
        ) : (
          <Skeleton />
        )}
      </ListingCard>
    </Row>
  );
};

export default HostProfileListing;
